/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Center_Left_Justify_Center_PosInputs */



/**
* | output |
* | --- |
* | "Left Justify / Center Position" |
*
* @param {Align_Center_Left_Justify_Center_PosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_center_left_justify_center_pos = /** @type {((inputs?: Align_Center_Left_Justify_Center_PosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Center_Left_Justify_Center_PosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Justification Gauche / Position Centree")
	if (locale === "de") return /** @type {LocalizedString} */ ("Linksbündig / Zentriert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giustifica a sinistra / Posizione centrale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выравнивание по левому краю / Центрирование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Justificar a la izquierda / Posición centrada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("左对齐/居中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左揃え / 中央揃え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाएँ संरेखित करें / मध्य स्थिति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Justificar à esquerda / Posicionamento centralizado")
	return /** @type {LocalizedString} */ ("Left Justify / Center Position")
});